import mware from 'mware'

export function middleware(project, name = 'project') {
  const m = mware(project)
  return m
}

export default middleware



// WEBPACK FOOTER //
// ./src/middleware.js